import { common } from '@mui/material/colors'

export const userRoles = {
	superAdmin: 'SuperAdmin',
	admin: 'Admin',
	scCounselor: 'ScCounselor',
	peeguCounselor: 'PeeguCounselor',
	scPrincipal: 'ScPrincipal',
	sseCounselor: 'SSECounselor',
	teacher: 'Teacher',
}

export const bulkUploadAllKeys = {
	classrooms: [
		'Class Name',
		'Class Hierarchy',
		'Section',
		'Section Hierarchy',
		'Teacher Id',
	],
	students: [
		'Student ID',
		'Classroom',
		'Section',
		'Student Name',
		'Reg_no',
		'Reg_date',
		'Nationality',
		'DOB',
		'Gender',
		'Blood_group',
		'Father Name',
		'Mother Name',
		'Email',
		'Phone_no',
		'profilePicture',
		'profilePicUrl',
	],
	teachers: [
		'Teachers ID',
		'Teachers Name',
		'Gender',
		'Email',
		'Phone Number',
	],
	baslineRecords: [
		'Student Id',
		'Class Group',
		'Baseline Category',
		'PhysicalQn1',
		'PhysicalQn2',
		'PhysicalQn3',
		'PhysicalQn4',
		'PhysicalQn5',
		'PhysicalQn6',
		'PhysicalQn7',
		'SocialQn1',
		'SocialQn2',
		'SocialQn3',
		'SocialQn4',
		'SocialQn5',
		'SocialQn6',
		'SocialQn7',
		'EmotionalQn1',
		'EmotionalQn2',
		'EmotionalQn3',
		'EmotionalQn4',
		'EmotionalQn5',
		'EmotionalQn6',
		'EmotionalQn7',
		'CognitiveQn1',
		'CognitiveQn2',
		'CognitiveQn3',
		'CognitiveQn4',
		'CognitiveQn5',
		'CognitiveQn6',
		'CognitiveQn7',
		'LanguageQn1',
		'LanguageQn2',
		'LanguageQn3',
		'LanguageQn4',
		'LanguageQn5',
		'LanguageQn6',
		'LanguageQn7',
	],
	sendChecklistRecords: ['Student ID'],
	teacherProfilingRecords: [
		'Teacher ID',
		'School Code',
		'Date of Assessment',
		'Teaching Attitude Q.1',
		'Teaching Attitude Q.2',
		'Teaching Attitude Q.3',
		'Teaching Attitude Q.4',
		'Teaching Attitude Q.5',
		'Teaching Attitude Q.6',
		'Teaching Attitude Q.7',
		'Teaching Attitude Q.8',
		'Teaching Attitude Q.9',
		'Teaching Attitude Q.10',
		'Teaching Attitude Q.11',
		'Teaching Attitude Q.12',
		'Teaching Practices Q.1',
		'Teaching Practices Q.2',
		'Teaching Practices Q.3',
		'Teaching Practices Q.4',
		'Teaching Practices Q.5',
		'Teaching Practices Q.6',
		'Teaching Practices Q.7',
		'Teaching Practices Q.8',
		'Teaching Practices Q.9',
		'Teaching Practices Q.10',
		'Teaching Practices Q.11',
		'Teaching Practices Q.12',
		'Job-Life Satisfaction Q.1',
		'Job-Life Satisfaction Q.2',
		'Job-Life Satisfaction Q.3',
		'Job-Life Satisfaction Q.4',
		'Job-Life Satisfaction Q.5',
		'Job-Life Satisfaction Q.6',
		'Job-Life Satisfaction Q.7',
		'Job-Life Satisfaction Q.8',
		'Job-Life Satisfaction Q.9',
		'DISC Profiles Q.1',
		'DISC Profiles Q.2',
		'DISC Profiles Q.3',
		'DISC Profiles Q.4',
		'DISC Profiles Q.5',
		'DISC Profiles Q.6',
		'DISC Profiles Q.7',
		'DISC Profiles Q.8',
		'DISC Profiles Q.9',
		'DISC Profiles Q.10',
		'DISC Profiles Q.11',
		'DISC Profiles Q.12',
		'DISC Profiles Q.13',
		'DISC Profiles Q.14',
		'DISC Profiles Q.15',
		'DISC Profiles Q.16',
	],
	teacherIRIRecords: [
		'Teacher ID',
		'School Code',
		'Date of Assessment',
		'Q.1',
		'Q.2',
		'Q.3',
		'Q.4',
		'Q.5',
		'Q.6',
		'Q.7',
		'Q.8',
		'Q.9',
		'Q.10',
		'Q.11',
		'Q.12',
		'Q.13',
		'Q.14',
		'Q.15',
		'Q.16',
		'Q.17',
		'Q.18',
		'Q.19',
		'Q.20',
		'Q.21',
		'Q.22',
		'Q.23',
		'Q.24',
		'Q.25',
		'Q.26',
		'Q.27',
		'Q.28',
	],
	studentWellBeingRecords: [
		'Student ID',
		'Date of Assessment',
		'CHS Q.1',
		'CHS Q.2',
		'CHS Q.3',
		'CHS Q.4',
		'CHS Q.5',
		'CHS Q.6',
		'PWB Q.1',
		'PWB Q.2',
		'PWB Q.3',
		'PWB Q.4',
		'PWB Q.5',
		'PWB Q.6',
		'PWB Q.7',
		'PWB Q.8',
		'PWB Q.9',
		'PWB Q.10',
		'PWB Q.11',
		'PWB Q.12',
		'PWB Q.13',
		'PWB Q.14',
		'PWB Q.15',
		'PWB Q.16',
		'PWB Q.17',
		'PWB Q.18',
	],
	studentCOPERecords: [
		'Student ID',
		'Date of Assessment',
		'Q.1',
		'Q.2',
		'Q.3',
		'Q.4',
		'Q.5',
		'Q.6',
		'Q.7',
		'Q.8',
		'Q.9',
		'Q.10',
		'Q.11',
		'Q.12',
		'Q.13',
		'Q.14',
		'Q.15',
		'Q.16',
		'Q.17',
		'Q.18',
		'Q.19',
		'Q.20',
		'Q.21',
		'Q.22',
		'Q.23',
		'Q.24',
		'Q.25',
		'Q.26',
		'Q.27',
		'Q.28',
		'Q.29',
		'Q.30',
		'Q.31',
		'Q.32',
		'Q.33',
		'Q.34',
		'Q.35',
		'Q.36',
	],
}

export const bulkUploadMandatoryKeys = {
	classrooms: [
		'Class Name',
		'Class Hierarchy',
		'Section',
		'Section Hierarchy',
	],
	students: [
		'Student ID',
		'Classroom',
		'Section',
		'Student Name',
		'Reg_no',
		'Reg_date',
		'DOB',
		'Gender',
	],
	teachers: ['Teachers ID', 'Teachers Name', 'Gender', 'Email'],
	baslineRecords: [
		'Student Id',
		'Class Group',
		'Baseline Category',
		'PhysicalQn1',
		'PhysicalQn2',
		'PhysicalQn3',
		'PhysicalQn4',
		'PhysicalQn5',
		'PhysicalQn6',
		'PhysicalQn7',
		'SocialQn1',
		'SocialQn2',
		'SocialQn3',
		'SocialQn4',
		'SocialQn5',
		'SocialQn6',
		'SocialQn7',
		'EmotionalQn1',
		'EmotionalQn2',
		'EmotionalQn3',
		'EmotionalQn4',
		'EmotionalQn5',
		'EmotionalQn6',
		'EmotionalQn7',
		'CognitiveQn1',
		'CognitiveQn2',
		'CognitiveQn3',
		'CognitiveQn4',
		'CognitiveQn5',
		'CognitiveQn6',
		'CognitiveQn7',
		'LanguageQn1',
		'LanguageQn2',
		'LanguageQn3',
		'LanguageQn4',
		'LanguageQn5',
		'LanguageQn6',
		'LanguageQn7',
	],
	sendChecklistRecords: ['Student ID'],
	teacherProfilingRecords: [
		'Teacher ID',
		'Date of Assessment',
		'Teaching Attitude Q.1',
		'Teaching Attitude Q.2',
		'Teaching Attitude Q.3',
		'Teaching Attitude Q.4',
		'Teaching Attitude Q.5',
		'Teaching Attitude Q.6',
		'Teaching Attitude Q.7',
		'Teaching Attitude Q.8',
		'Teaching Attitude Q.9',
		'Teaching Attitude Q.10',
		'Teaching Attitude Q.11',
		'Teaching Attitude Q.12',
		'Teaching Practices Q.1',
		'Teaching Practices Q.2',
		'Teaching Practices Q.3',
		'Teaching Practices Q.4',
		'Teaching Practices Q.5',
		'Teaching Practices Q.6',
		'Teaching Practices Q.7',
		'Teaching Practices Q.8',
		'Teaching Practices Q.9',
		'Teaching Practices Q.10',
		'Teaching Practices Q.11',
		'Teaching Practices Q.12',
		'Job-Life Satisfaction Q.1',
		'Job-Life Satisfaction Q.2',
		'Job-Life Satisfaction Q.3',
		'Job-Life Satisfaction Q.4',
		'Job-Life Satisfaction Q.5',
		'Job-Life Satisfaction Q.6',
		'Job-Life Satisfaction Q.7',
		'Job-Life Satisfaction Q.8',
		'Job-Life Satisfaction Q.9',
		'DISC Profiles Q.1',
		'DISC Profiles Q.2',
		'DISC Profiles Q.3',
		'DISC Profiles Q.4',
		'DISC Profiles Q.5',
		'DISC Profiles Q.6',
		'DISC Profiles Q.7',
		'DISC Profiles Q.8',
		'DISC Profiles Q.9',
		'DISC Profiles Q.10',
		'DISC Profiles Q.11',
		'DISC Profiles Q.12',
		'DISC Profiles Q.13',
		'DISC Profiles Q.14',
		'DISC Profiles Q.15',
		'DISC Profiles Q.16',
	],
	teacherIRIRecords: [
		'Teacher ID',
		'Date of Assessment',
		'Q.1',
		'Q.2',
		'Q.3',
		'Q.4',
		'Q.5',
		'Q.6',
		'Q.7',
		'Q.8',
		'Q.9',
		'Q.10',
		'Q.11',
		'Q.12',
		'Q.13',
		'Q.14',
		'Q.15',
		'Q.16',
		'Q.17',
		'Q.18',
		'Q.19',
		'Q.20',
		'Q.21',
		'Q.22',
		'Q.23',
		'Q.24',
		'Q.25',
		'Q.26',
		'Q.27',
		'Q.28',
	],
	studentWellBeingRecords: [
		'Student ID',
		'Date of Assessment',
		'CHS Q.1',
		'CHS Q.2',
		'CHS Q.3',
		'CHS Q.4',
		'CHS Q.5',
		'CHS Q.6',
		'PWB Q.1',
		'PWB Q.2',
		'PWB Q.3',
		'PWB Q.4',
		'PWB Q.5',
		'PWB Q.6',
		'PWB Q.7',
		'PWB Q.8',
		'PWB Q.9',
		'PWB Q.10',
		'PWB Q.11',
		'PWB Q.12',
		'PWB Q.13',
		'PWB Q.14',
		'PWB Q.15',
		'PWB Q.16',
		'PWB Q.17',
		'PWB Q.18',
	],
	studentCOPERecords: [
		'Student ID',
		'Date of Assessment',
		'Q.1',
		'Q.2',
		'Q.3',
		'Q.4',
		'Q.5',
		'Q.6',
		'Q.7',
		'Q.8',
		'Q.9',
		'Q.10',
		'Q.11',
		'Q.12',
		'Q.13',
		'Q.14',
		'Q.15',
		'Q.16',
		'Q.17',
		'Q.18',
		'Q.19',
		'Q.20',
		'Q.21',
		'Q.22',
		'Q.23',
		'Q.24',
		'Q.25',
		'Q.26',
		'Q.27',
		'Q.28',
		'Q.29',
		'Q.30',
		'Q.31',
		'Q.32',
		'Q.33',
		'Q.34',
		'Q.35',
		'Q.36',
	],
}

export const reportsIncludePages = {
	teacherIRI: {
		fs: {
			standard: ['page-010', 'page-014', 'page-015'],
			outlier: ['page-012', 'page-017', 'page-018'],
		},
		ec: {
			standard: ['page-022', 'page-026', 'page-027'],
			outlier: ['page-024', 'page-029', 'page-030'],
		},
		pt: {
			standard: ['page-034', 'page-038', 'page-039'],
			outlier: ['page-036', 'page-041', 'page-042'],
		},
		pd: {
			standard: ['page-046', 'page-050', 'page-051'],
			outlier: ['page-048', 'page-053', 'page-054'],
		},
		common: [
			'page-002',
			'page-003',
			'page-004',
			'page-005',
			'page-008',
			'page-020',
			'page-032',
			'page-044',
			'page-056',
			'page-057',
		],
	},
	teacherProfiling: {
		common: [
			'page-002',
			'page-003',
			'page-004',
			'page-005',
			'page-006',
			'page-007',
			'page-069',
		],
		dominance: {
			common: [
				'page-009',
				'page-010',
				'page-011',
				'page-012',
				'page-013',
				'page-020',
				'page-021',
				'page-022',
			],
			editable: {
				DI: ['page-015', 'page-016'],
				DC: ['page-017', 'page-018'],
			},
		},

		influence: {
			common: [
				'page-024',
				'page-025',
				'page-026',
				'page-027',
				'page-028',
				'page-035',
				'page-036',
				'page-037',
			],
			editable: {
				IS: ['page-030', 'page-031'],
				ID: ['page-032', 'page-033'],
			},
		},

		steadiness: {
			common: [
				'page-039',
				'page-040',
				'page-041',
				'page-042',
				'page-043',
				'page-050',
				'page-051',
				'page-052',
			],
			editable: {
				SI: ['page-045', 'page-046'],
				SC: ['page-047', 'page-048'],
			},
		},

		compliance: {
			common: [
				'page-054',
				'page-055',
				'page-056',
				'page-057',
				'page-058',
				'page-065',
				'page-066',
				'page-067',
			],
			editable: {
				CD: ['page-060', 'page-061'],
				CS: ['page-062', 'page-063'],
			},
		},
		invalid: [
			'page-002',
			'page-003',
			'page-004',
			'page-005',
			'page-007',
			'page-071',
		],
	},
}
